export default class KeyAreaSkillLevel {
  id: string;

  expected: number;

  name: string;

  active: boolean;

  isDeletable: boolean;

  constructor(obj: any = {}) {
    this.id = obj.id;
    this.expected = obj.expected;
    this.name = obj.name;
    this.active = obj.active;
    this.isDeletable = obj.isDeletable;
  }

  get isConfigured() {
    return this.expected !== null && this.expected !== undefined;
  }
}
